import { stringify } from "query-string";
import VerificationCodeResponse from "shared/models/verificationCodeResponse";
import { AuthMethod } from "shared/constants/enums";
import { httpGet, httpPost } from "shared/api/apiHandler";
import LoginOptions from "shared/models/loginOptions";
import urls from "shared/api/auth/urls";

export const requestAuthCode = async (email: string, authMethod: AuthMethod): Promise<VerificationCodeResponse> => {
    const data = {
        email,
        authMethod,
    };

    const result = await httpPost<VerificationCodeResponse>(
        window.APP_SETTINGS.authApiBaseUri,
        urls.AUTH.REQUEST_LOGIN_CODE,
        data
    );

    return result.data;
};

export const startLogin = async (email: string): Promise<LoginOptions> => {
    const result = await httpGet<LoginOptions>(
        window.APP_SETTINGS.authApiBaseUri,
        `${urls.AUTH.LOGIN_OPTIONS}?${stringify({ email })}`
    );

    return result.data;
};
